export default "__VITE_ASSET__db8707de__"